import { Button } from '@atom-web/micros'
import { Space } from '@pyt/micros'
import { useContext, useEffect, useState } from 'react'

import capitializeFirstChar from '../../../utils/capitializeFirstChar'
import { FilterFooter } from '../../FilterModal'
import { TRAVEL_TYPE, UPDATE_COSTING } from '../Constants'
import GCMContext from '../GCMContext'
import { getCostingBasedOntype, getPaxTypes } from '../utils/getCostingText'
import PAX from '../widgets/pax/Pax'
import GroupButton from './GroupButton'

/**
 * Mobile component to get the room & pax related info
 * @param {String} headerText - Headet Text for the screen
 * @param {Function} onChange - callback method once they choosen the config
 * @param {Function} onLeftClick - action for header left button (back event)
 * @param {Function} onRightClick - action for header right button (close)
 */
const RoomsInfo = ({
	showRoomConfig,
	onChange,
	ctaText,
	onRightClick,
	showOnlyAgeField,
	roomConfiguration,
	regionName = '',
	packages,
	itineraryInfo,
	showUserIntent: propShowUserIntent = true,
	isLoggedIn,
	onSumbit,
	loading,
	setPassengerType,
}) => {
	// get the hote room config from context
	// set default values if it is not set
	const [
		{
			hotelGuestRoomConfigurations = [
				{
					adultCount: 2,
					childAges: [],
				},
			],
			// userIntent,
		},
		dispatch,
	] = useContext(GCMContext)

	const packagesRegionCode = packages?.campaignDetails?.regionCode
	const itineraryRegionCode = itineraryInfo?.campaignDetail?.regionCode
	const isMle =
		propShowUserIntent !== false &&
		(packagesRegionCode === 'mle' ||
			itineraryRegionCode === 'mle' ||
			regionName === 'mle')

	// maintain pax count choosen in separate state
	const [paxType, setPaxType] = useState(null)
	// flag to show room config option - this is set to true if the paxType is not SOLO/COUPLE
	const [showRoomOptions, setShowRoomOptions] = useState(showRoomConfig || null)
	// initial room config options - each object in array represent one room
	// default value is 1 room 2 adults
	const [roomConfig, setRoomConfig] = useState(hotelGuestRoomConfigurations)

	// to enable calling the submit function of PaxWrapper component - for age error check
	const [saveAgeDetailsMobile] = useState(0)

	const [ctaDisabled, setCtaDisabled] = useState(true)

	// trigger a method once paxType is updated
	// invoke onChange callback if the paxType is SOLO/COUPLE
	// set showRoomOptions flag to true if the paxType is not SOLO/COUPLE to get the actual pax & room details
	useEffect(() => {
		if (typeof paxType === 'string') {
			if (paxType === 'SOLO' || paxType === 'COUPLE') {
				if (isMle) {
					// setShowUserIntent(true)
				} else {
					const t = getCostingBasedOntype(paxType)
					typeof onChange === 'function' && onChange(t, paxType)
					onSumbit && onSumbit({ t, paxType })
				}
			} else {
				dispatch({
					type: TRAVEL_TYPE,
					payload: {
						travelType: paxType,
					},
				})
				setShowRoomOptions(true)
			}
		}
		setPassengerType && setPassengerType(capitializeFirstChar(paxType))
	}, [paxType])

	useEffect(() => {
		dispatch({
			type: UPDATE_COSTING,
			payload: {
				hotelGuestRoomConfigurations: roomConfig,
			},
		})
	}, [roomConfig])

	const getRoomConfig = () => {
		// remove null values from childAges array
		// null will be added to childAges array if user adds a child without proper age
		return Array.isArray(roomConfig)
			? roomConfig.map(roomData => {
					return {
						adultCount: roomData.adultCount,
						childAges: roomData.childAges.filter(
							ageValue => !isNaN(parseInt(ageValue)),
						), // filter out invalid values
					}
			  })
			: [{ adultCount: 2, childAges: [] }]
	}

	const onSubmitRoomInfo = () => {
		typeof onChange === 'function' && onChange(getRoomConfig(), paxType)
		onSumbit && onSumbit()
	}

	const onSavePaxAgeConfig = () => {
		const result = Array.isArray(roomConfig)
			? roomConfig.map(roomData => {
					return {
						adultCount: roomData.adultCount,
						adultAges: [...roomData.adultAges],
						childAges: roomData.childAges.filter(
							ageValue => !isNaN(parseInt(ageValue)),
						), // filter out invalid values
					}
			  })
			: [{ adultCount: 2, childAges: [] }]
		typeof onChange === 'function' && onChange(result, paxType)
	}

	const showOnlyAgeFieldProps = showOnlyAgeField
		? {
				successCallback: onSavePaxAgeConfig,
				cancelCallback: onRightClick,
				triggerSubmit: saveAgeDetailsMobile,
		  }
		: {}
	return (
		<Space gutter={0} direction="column" justifyContent={'space-between'}>
			<div style={{ padding: '24px' }}>
				{showRoomOptions ? (
					<PAX
						setCtaDisabled={setCtaDisabled}
						isLoggedIn={isLoggedIn}
						noDropdown
						roomConfig={showOnlyAgeField ? roomConfiguration : roomConfig}
						onChangeAction={setRoomConfig}
						showOnlyAgeField={showOnlyAgeField}
						{...showOnlyAgeFieldProps}
					/>
				) : (
					<GroupButton
						vertical
						callBackAction={setPaxType}
						groupButtonText={getPaxTypes()}
					/>
				)}
			</div>
			{showRoomOptions ? (
				<FilterFooter noShadow padding={'24px'} top="10px">
					<Button
						primary
						disabled={ctaDisabled}
						onClick={onSubmitRoomInfo}
						loading={loading}
						css={{
							width: '100%',
						}}
					>
						{ctaText || 'Continue'}
					</Button>
				</FilterFooter>
			) : null}
		</Space>
	)
}

export default RoomsInfo
